import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type SelfCheckInDetails = {
  odo: number | null;
  soc: number | null;
}

const initialState: SelfCheckInDetails = {
  odo: null,
  soc: null
};

const selfCheckInDetailsSlice = createSlice({
  name: "selfCheckInDetails",
  initialState,
  reducers: {
    setSelfCheckInDetails: (state, action: PayloadAction<{ odo: number; soc: number }>) => {
      state.odo = action.payload.odo;
      state.soc = action.payload.soc;
    },
    resetSelfCheckInDetails: (state) => {
      state.odo = null;
      state.soc = null;
    }
  },
});

export const { setSelfCheckInDetails, resetSelfCheckInDetails } = selfCheckInDetailsSlice.actions;
export default selfCheckInDetailsSlice.reducer; 